import styles from './CarriedPanelGuide.module.scss';

/**
 * How to work the Carried panel, shown while no slot is selected so that
 * coalescing, equipping and linking keys are found without guessing.
 */
export function CarriedPanelGuide(): JSX.Element {
    return (
        <section className={styles.carriedPanelGuide} aria-label='How to use the Carried panel'>
            <h3 className={styles.heading}>How to</h3>
            <ul className={styles.steps}>
                <li>
                    <span className={styles.term}>Coalesce a crystal:</span>
                    {' click an empty slot, then pick a crystal. It is formed from your essence.'}
                </li>
                <li>
                    <span className={styles.term}>Crystals:</span>
                    {' click a stack to see what it does, or to coalesce more of its kind.'}
                </li>
                <li>
                    <span className={styles.term}>Gear:</span>
                    {' click it to compare it with what you wear and equip it, or drag it onto a Loadout frame.'}
                </li>
                <li>
                    <span className={styles.term}>Move:</span>
                    {' drag an item to another slot, or right-click it for its options.'}
                </li>
                <li>
                    <span className={styles.term}>Action bar:</span>
                    {' click a slot\'s key plate, then press an action slot\'s key to put it there.'}
                </li>
                <li>
                    <span className={styles.term}>Essence abilities:</span>
                    {' right-click an action slot to choose one.'}
                </li>
            </ul>
        </section>
    );
}
